export default {
    name: 'CheckoutHeader',
    setup() {}
}
